import React from 'react';
import {Modal,Icon} from 'antd';
import 'antd/dist/antd.css';
import {setCookie} from './service/common.js';

function showConfirm(that) {
  Modal.confirm({
    title: '登录',
    content: '此功能需要登录个人账号，是否立即登录？',
    okText:'登录',
    cancelText:'以后再说',
    icon:<Icon type="exclamation-circle" width="30px" />,
    centered:true,
    maskClosable:true,
    okButtonProps:{style:{background:'#e75934',border:'1px solid #e75934'}},
    cancelButtonProps:{style:{color:'#999',border:'1px solid #999'}},
    onOk() {
      if(that.props.locationTarget) {
        setCookie('loginTargetUrl',that.props.locationTarget,{time:0.1});
      } else {
        setCookie('loginTargetUrl',window.location.href,{time:0.1});
      }
      window.location.href='/account.html';
    },
    onCancel() {},
  });
}
class LoginPopConfirm extends React.Component{
        render() {
            var button = this.props.button;
            return (
                <span onClick={()=>{showConfirm(this)}}>
                    {button}
                </span> 
            )
        }
    }

export default LoginPopConfirm;